// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let IconV5 = require("../../../uikit/atoms/Icon/IconV5.bs.js");
let MenuV5 = require("../../common/Components/menu/MenuV5.bs.js");
let ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let MyClientsWidgetRowLayout = require("./MyClientsWidgetRowLayout.bs.js");
let MyClientsWidgetDeleteDialog = require("./MyClientsWidgetDeleteDialog.bs.js");
let MyClientsWidgetDeveloper_developer_graphql = require("../../../__generated__/MyClientsWidgetDeveloper_developer_graphql.bs.js");
let MyClientsWidgetDeveloper_Menu_developer_graphql = require("../../../__generated__/MyClientsWidgetDeveloper_Menu_developer_graphql.bs.js");
let MyClientsWidgetDeveloper_name_developer_graphql = require("../../../__generated__/MyClientsWidgetDeveloper_name_developer_graphql.bs.js");
let MyClientsWidgetDeveloper_Menu_ActivityReportMenuItem_developmentProject_graphql = require("../../../__generated__/MyClientsWidgetDeveloper_Menu_ActivityReportMenuItem_developmentProject_graphql.bs.js");

let convertFragment = MyClientsWidgetDeveloper_Menu_ActivityReportMenuItem_developmentProject_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MyClientsWidgetDeveloper_Menu_ActivityReportMenuItem_developmentProject_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(MyClientsWidgetDeveloper_Menu_ActivityReportMenuItem_developmentProject_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, MyClientsWidgetDeveloper_Menu_ActivityReportMenuItem_developmentProject_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(MyClientsWidgetDeveloper_Menu_ActivityReportMenuItem_developmentProject_graphql.node, convertFragment, fRef);
}

let DevelopmentProjectFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function MyClientsWidgetDeveloper$Menu$ActivityReportMenuItem(props) {
  let developmentProject = RescriptRelay_Fragment.useFragment(MyClientsWidgetDeveloper_Menu_ActivityReportMenuItem_developmentProject_graphql.node, convertFragment, props.developmentProject);
  let hasActivityReport = Stdlib_Array.keepSome(Stdlib_Option.getOr(Stdlib_Option.map(developmentProject.broadcasts, connection => connection.edges), [])).some(edge => {
    let match = edge.node.activityReport;
    return match.__typename === "ActivityReportV5";
  });
  if (hasActivityReport) {
    return JsxRuntime.jsx(MenuV5.MenuItem.make, {
      href: `/developments/` + developmentProject.id + `/report`,
      children: "View activity report"
    });
  } else {
    return null;
  }
}

let ActivityReportMenuItem = {
  DevelopmentProjectFragment: DevelopmentProjectFragment,
  make: MyClientsWidgetDeveloper$Menu$ActivityReportMenuItem
};

let convertFragment$1 = MyClientsWidgetDeveloper_Menu_developer_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MyClientsWidgetDeveloper_Menu_developer_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(MyClientsWidgetDeveloper_Menu_developer_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, MyClientsWidgetDeveloper_Menu_developer_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(MyClientsWidgetDeveloper_Menu_developer_graphql.node, convertFragment$1, fRef);
}

let DeveloperFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function MyClientsWidgetDeveloper$Menu(props) {
  let developer = RescriptRelay_Fragment.useFragment(MyClientsWidgetDeveloper_Menu_developer_graphql.node, convertFragment$1, props.developer);
  let match = React.useState(() => false);
  let setDeleteDialogOpen = match[1];
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx(MyClientsWidgetDeleteDialog.make, {
        client: developer.fragmentRefs,
        isOpen: match[0],
        onCancel: () => setDeleteDialogOpen(param => false),
        onSuccess: () => setDeleteDialogOpen(param => false),
        connectionId: props.connectionId
      }),
      JsxRuntime.jsxs(MenuV5.Menu.make, {
        button: JsxRuntime.jsx(ButtonsV5.Button.make, {
          className: "!border-none",
          children: JsxRuntime.jsx(IconV5.make, {
            icon: "three-dots",
            size: 16,
            className: "text-black"
          })
        }),
        children: [
          JsxRuntime.jsx(MenuV5.MenuItem.make, {
            href: `/developments/` + developer.developmentProject.id,
            children: "View development"
          }),
          JsxRuntime.jsx(MenuV5.MenuItem.make, {
            href: `/developments/` + developer.developmentProject.id + `/edit`,
            children: "Edit development"
          }),
          JsxRuntime.jsx(React.Suspense, {
            children: JsxRuntime.jsx(MyClientsWidgetDeveloper$Menu$ActivityReportMenuItem, {
              developmentProject: developer.developmentProject.fragmentRefs
            }),
            fallback: null
          }),
          JsxRuntime.jsx(MenuV5.MenuItem.make, {
            onAction: () => setDeleteDialogOpen(param => true),
            children: "Delete developer"
          })
        ]
      })
    ]
  });
}

let Menu = {
  ActivityReportMenuItem: ActivityReportMenuItem,
  DeveloperFragment: DeveloperFragment,
  make: MyClientsWidgetDeveloper$Menu
};

let convertFragment$2 = MyClientsWidgetDeveloper_name_developer_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MyClientsWidgetDeveloper_name_developer_graphql.node, convertFragment$2, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(MyClientsWidgetDeveloper_name_developer_graphql.node, convertFragment$2, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, MyClientsWidgetDeveloper_name_developer_graphql.node, convertFragment$2);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(MyClientsWidgetDeveloper_name_developer_graphql.node, convertFragment$2, fRef);
}

let DeveloperFragment$1 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$2,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2
};

function MyClientsWidgetDeveloper$Name(props) {
  let developer = RescriptRelay_Fragment.useFragment(MyClientsWidgetDeveloper_name_developer_graphql.node, convertFragment$2, props.developer);
  let project = developer.developmentProject;
  let projectName = Stdlib_Option.getOr(project.name, "Untitled development");
  let match = project.location;
  let addressText;
  if (match !== undefined) {
    switch (match.__typename) {
      case "PropertyLocationWithHiddenAddress" :
        addressText = match.locationDisplay;
        break;
      case "PropertyLocationWithVisibleAddress" :
        addressText = match.address + `, ` + match.locationDisplay;
        break;
      case "__unselected" :
        addressText = undefined;
        break;
    }
  } else {
    addressText = undefined;
  }
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: "Development project",
        className: "text-gray-500 text-sm font-semibold uppercase tracking-wide"
      }),
      JsxRuntime.jsx(ButtonsV5.Link.make, {
        href: `my_clients/` + developer.id,
        children: JsxRuntime.jsx("div", {
          children: developer.displayName,
          className: "text-lg font-medium"
        })
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("span", {
            children: projectName
          }),
          addressText !== undefined ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsx("span", {
                  children: "•",
                  className: "text-gray-400"
                }),
                JsxRuntime.jsx("span", {
                  children: addressText
                })
              ]
            }) : null
        ],
        className: "text-base text-gray-500 flex flex-wrap items-center gap-x-1"
      })
    ],
    className: "flex flex-col gap-1"
  });
}

let Name = {
  DeveloperFragment: DeveloperFragment$1,
  make: MyClientsWidgetDeveloper$Name
};

let convertFragment$3 = MyClientsWidgetDeveloper_developer_graphql.Internal.convertFragment;

function waitForFragmentData$3(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MyClientsWidgetDeveloper_developer_graphql.node, convertFragment$3, fRef);
}

function use$3(fRef) {
  return RescriptRelay_Fragment.useFragment(MyClientsWidgetDeveloper_developer_graphql.node, convertFragment$3, fRef);
}

function useOpt$3(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, MyClientsWidgetDeveloper_developer_graphql.node, convertFragment$3);
}

function readResolverFragment$3(fRef) {
  return RescriptRelay_Fragment.read(MyClientsWidgetDeveloper_developer_graphql.node, convertFragment$3, fRef);
}

let DeveloperFragment$2 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$3,
  waitForFragmentData: waitForFragmentData$3,
  use: use$3,
  useOpt: useOpt$3,
  readResolverFragment: readResolverFragment$3
};

function MyClientsWidgetDeveloper(props) {
  let developer = RescriptRelay_Fragment.useFragment(MyClientsWidgetDeveloper_developer_graphql.node, convertFragment$3, props.developer);
  return JsxRuntime.jsx(MyClientsWidgetRowLayout.make, {
    name: JsxRuntime.jsx(MyClientsWidgetDeveloper$Name, {
      developer: developer.fragmentRefs
    }),
    status: null,
    matches: null,
    menu: JsxRuntime.jsx(MyClientsWidgetDeveloper$Menu, {
      developer: developer.fragmentRefs,
      connectionId: props.connectionId
    })
  });
}

let Link;

let DeleteDialog;

let make = MyClientsWidgetDeveloper;

exports.Link = Link;
exports.DeleteDialog = DeleteDialog;
exports.Menu = Menu;
exports.Name = Name;
exports.DeveloperFragment = DeveloperFragment$2;
exports.make = make;
/* react Not a pure module */
